import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import authRoutes from 'routes/authRoutes';
import styles from 'assets/jss/material-dashboard-pro-react/layouts/authStyle';
import classNames from 'classnames';
import AuthPicture from 'assets/img/auth_picture.svg';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import Button from 'components/CustomButtons/Button';
import Logo from 'components/Logo/Logo';
import { translate } from 'components/Translation';
import { setLanguage } from 'redux/modules/settings/language/actions';
import { fetchLabels } from 'utils/labels/labels';
import { updateTranslations } from 'redux/modules/dynamicLabels/actions';
import BusinessLink from 'components/BusinessLink/BusinessLink';
import { BodyMBold } from 'components/Typography/Typography';

const useStyles = makeStyles(styles);

export default function Pages() {
	const [cardAnimation, setCardAnimation] = React.useState('cardHidden');

	// ref for the wrapper div
	const wrapper = React.createRef();
	// styles
	const classes = useStyles();
	React.useEffect(() => {
		document.body.style.overflow = 'unset';
		// Specify how to clean up after this effect:
		return function cleanup() {};
	});
	const getRoutes = (routes) => {
		return routes.map((prop, key) => {
			return <Route path={prop.layout + prop.path} render={(props) => <prop.component {...props} />} key={key} />;
		});
	};

	const cardClasses = classNames({
		[classes[cardAnimation]]: true,
		[classes.card]: true,
	});

	setTimeout(function() {
		setCardAnimation('');
	}, 700);

	const currentLanguage = useSelector((state) => state.settings.language);
	const changeLanguageTo = currentLanguage.toLowerCase() === 'en' ? 'ar' : 'en';

	const dispatch = useDispatch();

	return (
		<div>
			<div className={classNames(classes.wrapper, classes.responsiveBackground)} ref={wrapper}>
				<div className={classes.fullPage}>
					<div className={classes.container}>
						<GridContainer justify="center" className={classes.relative}>
							<GridItem xs={12} sm={7} md={9}>
								<div className={classes.buttonContainer}>
									<Button
										size="sm"
										color="tertiary-dark"
										onClick={() => {
											fetchLabels(changeLanguageTo);
											dispatch(setLanguage(changeLanguageTo));
										}}
										id="change-language"
									>
										{translate(`auth.${changeLanguageTo}`)}
									</Button>
								</div>

								<Card className={cardClasses} raised>
									<GridContainer>
										<GridItem xs={12} md={6} lg={7} className={classes.cardText}>
											<div className={classes.bodyWrapper}>
												<CardBody>
													<div className={classes.logo}>
														<BusinessLink>
															<Logo color="color" size="rg" />
														</BusinessLink>
													</div>
												</CardBody>
												<Switch>
													{getRoutes(authRoutes)}
													<Redirect from="/auth" to="/auth/login-page" />
												</Switch>
											</div>
										</GridItem>
										<GridItem md={6} lg={5} classes={{ root: classes.pictureContainer }}>
											<img src={AuthPicture} alt="login" />
										</GridItem>
									</GridContainer>
								</Card>
							</GridItem>
							<div className={classes.footer}>
								<BodyMBold color="primary-dark">{translate('copyright')}</BodyMBold>
							</div>
						</GridContainer>
					</div>
				</div>
			</div>
		</div>
	);
}
